import Reac, { Suspense, lazy, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./index.css";
import { useLocation } from "react-router-dom";

export default function Banner() {
  const imgCDNURL = process.env.REACT_APP_CDN + "evolutionai/images/";

  return (
    <div className="banner">
      <Container>
        <Row>
          <Col sm={12} md={12} lg={6} xl={6} className="banner-col">
            <h1 className="banner-heading">Ai-Driven Loan <br />Origination</h1>
            <p className="banner-text">Loan Officers 10X your business, 1/10<sup>th</sup> the work!<br className='mobileignore' /> Embrace the Ai mortgage evolution!</p>

            <div className="get-in-touch-wrapper">
              <h2 className="get-in-touch-heading">Get in Touch</h2>
              <div className="get-in-touch-container">
                <div className="get-in-touch-content">
                  <p className="get-in-touch-paragraph">
                    Thank you for accessing the EvolutionAI Mortgage site. The site you are trying to
                    access is currently not available in your country or region.
                  </p>
                  <p className="get-in-touch-paragraph">
                    In case you need any assistance, do not hesitate to connect with us at <a href="https://www.swmc.com/angelai" target='_blank'>askangel.ai/evolution</a>.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={6} xl={6} className="angelai-animation-col">
            <img src={imgCDNURL + "angelai-animation.webp"} alt="AngelAi Animation" className="angelai-animation" />
          </Col>
        </Row>
      </Container>


    </div>
  )
}
